<template>
  <v-container v-if="!loading" class="full-height">
    <div class="flex">
      <div class="d-flex flex justify-end">
        <v-btn class="white--text" color="third" @click="openAssignHorseModal">Add Horse</v-btn>
      </div>
      <div class="flex">
        <v-data-table
          :headers="headers"
          :items="customerHorses"
          hide-default-footer
        />
      </div>
    </div>
    <Modal v-if="showAddHorseModal" :show="showAddHorseModal" :max-width="'500'" :close="closeAssignHorseModal">
      <template #title>
        <div class="col-12">
          <h2 class="text-center third--text">Ajouter des chevaux</h2>
        </div>
      </template>
      <template #text>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          class="pb-4 pt-0 mt-0 mr-4"
        />
        <v-data-table
          v-model="selectedHorses"
          height="480"
          show-select
          :items="workspaceHorses"
          item-key="uuid"
          :search="search"
          :hide-default-footer="true"
          :items-per-page="-1"
          :headers="headers"
          checkbox-color="third"
        />
      </template>
      <template #actions>
        <div class="d-flex flex-grow-1 justify-end">
          <v-btn class="white--text mr-2" color="third" @click="closeAssignHorseModal"> Close </v-btn>
          <v-btn class="white--text" color="third" @click="addHorseToCustomer"> Ajouter </v-btn>
        </div>
      </template>
    </Modal>
  </v-container>
  <v-container v-else class="full-height">
    <div class="d-flex justify-center align-center full-height">
      <Loader />
    </div>
  </v-container>
</template>

<script>
import { ref, computed, onBeforeMount } from '@vue/composition-api';
import Modal from '@/components/common/Modal.vue';
import store from '@/store';
import { updateHorses } from '@/helpers/request';
import Loader from '@/components/common/Loader.vue';
import { sendNotification } from '@/helpers/utils';

export default {
  components: { Modal, Loader },
  props: {
    customer: {
      type: Object,
      default: null
    }
  },
  setup (props) {
    const loading = ref(false);
    const showAddHorseModal = ref(false);
    const selectedHorses = ref([]);
    const search = ref(null);

    const workspaceHorses = computed(() => store.state.horses);
    const customerHorses = ref([]);

    const headers = ref([
      { text: 'Nom', value: 'horse_name' },
      { text: 'Type', value: 'horse_type' }
    ]);

    /* Modal Logic */
    const openAssignHorseModal = () => {
      showAddHorseModal.value = true;
    };

    const closeAssignHorseModal = () => {
      showAddHorseModal.value = false;
    };

    const prepareHorses = () => {
      const horsesObjects = [];

      selectedHorses.value.map(horse => {
        if (!customerHorses.value.find(h => h.uuid === horse.uuid)) {
          const horseOwners = horse.owners && horse.owners.length ? [...horse.owners, { ownerUuid: props.customer.uuid }] : [{ ownerUuid: props.customer.uuid }];
          horsesObjects.push({ uuid: horse.uuid, horse_name: horse.horse_name, horse_type: horse.type, owners: horseOwners, isUcpaOwned: false, status: horse.status });
        }
      });

      customerHorses.value.map(horse => {
        if (!selectedHorses.value.find(h => h.uuid === horse.uuid)) {
          const horseOwners = horse.owners && horse.owners.length ? horse.owners.filter(o => o.ownerUuid !== props.customer.uuid) : [];
          horsesObjects.push({ uuid: horse.uuid, horse_name: horse.horse_name, horse_type: horse.type, owners: horseOwners, isUcpaOwned: true, status: horse.status });
        }
      });

      return horsesObjects;
    };

    const addHorseToCustomer = async () => {
      loading.value = true;
      const horsesToUpdate = prepareHorses();

      const updatedHorses = await updateHorses(horsesToUpdate);

      const successfullyUpdatedHorses = (updatedHorses.data || []).filter(i => i.success && i.data).map(item => ({ uuid: item.data.uuid, name: item.data.horse_name, type: item.data.horse_type, workspace: item.data.workspace }));

      if (!successfullyUpdatedHorses.length) {
        sendNotification('error', 'A rencontré une erreur lors de la mise à jour des chevaux.');
        closeAssignHorseModal();
        loading.value = false;
        return null;
      }

      store.dispatch('updateHorses', horsesToUpdate);
      customerHorses.value = store.getters.horsesFromCustomer(props.customer.uuid);
      sendNotification('success', 'Client mis à jour avec succès avec chevaux.');
      closeAssignHorseModal();
      loading.value = false;
    };

    onBeforeMount(async () => {
      loading.value = true;
      if (!store.state.isLazyLoaded.horses) {
        await store.dispatch('getHorses');
      }
      customerHorses.value = store.getters.horsesFromCustomer(props.customer.uuid);
      selectedHorses.value = customerHorses.value;
      loading.value = false;
    });

    return { headers, showAddHorseModal, openAssignHorseModal, closeAssignHorseModal, selectedHorses, workspaceHorses, search, addHorseToCustomer, loading, customerHorses };
  }
};
</script>
